import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: 'home'
  },
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/home/home.vue'),
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/about')
  },
  {
    path: '/serve',
    name: 'serve',
    component: () => import(/* webpackChunkName: "about" */ '../views/servProduc/serve')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import(/* webpackChunkName: "about" */ '../views/servProduc/product')
  },
  {
    path: '/solution',
    name: 'solution',
    component: () => import(/* webpackChunkName: "about" */ '../views/servProduc/solution')
  },
  {
    path: '/caseCenter',
    name: 'caseCenter',
    component: () => import(/* webpackChunkName: "about" */ '../views/caseCenter')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import(/* webpackChunkName: "about" */ '../views/news')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "about" */ '../views/contact')
  },
  {
    path: '/newsDetail',
    name: 'newsDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/newsDetail')
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {   //路由守卫，每次路由跳转重置一下滚动条高度
  document.documentElement.scrollTop = 0
  next()
})

export default router
